export interface OnboardingState {
  hasProfile: boolean;
  hasLocalOffice: boolean;
  hasBankAccount: boolean;
  hasClaim: boolean;
}

export interface OnboardingStep {
  key: string;
  label: string;
  done: boolean;
  ctaLabel: string;
  routeName: string;
}

export function buildSteps(state: OnboardingState): OnboardingStep[] {
  return [
    { key: "profile", label: "Complete your profile", done: !!state.hasProfile, ctaLabel: "Update profile", routeName: "claimant-info" },
    { key: "local-office", label: "Set your local NIB office", done: !!state.hasLocalOffice, ctaLabel: "Choose office", routeName: "settings" },
    { key: "banking", label: "Add your banking details", done: !!state.hasBankAccount, ctaLabel: "Add banking", routeName: "banking-details" },
    { key: "first-claim", label: "Explore benefits & submit a claim", done: !!state.hasClaim, ctaLabel: "View benefits", routeName: "claims-index" },
  ];
}

export function allDone(steps: OnboardingStep[]): boolean {
  return steps.every((s) => s.done);
}

export function isChecklistVisible(args: {
  steps: OnboardingStep[];
  dismissedAt: string | null;
  nowMs: number;
}): boolean {
  if (allDone(args.steps)) return false;
  if (args.dismissedAt) return false; // once dismissed, stays dismissed
  return true;
}
